import PolyFinTechLayout from '../../views/polyfintech/polyfintech_layout.jsx'

const PolyFinTechPage = () => {
  return (
      <PolyFinTechLayout />
  );
};

export default PolyFinTechPage;